var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockPadlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19365_371271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9231 0.5625C8.84308 0.5625 5.31323 2.25542 3.11446 5.00435C0.919385 7.75512 0 11.3182 0 15.1582V20.8702H5.53846V15.1582C5.53846 12.2413 6.25662 9.95204 7.44185 8.46588C8.62892 6.98158 10.2295 6.10096 12.9231 6.10096C15.624 6.10096 17.2209 6.93173 18.4043 8.40865C19.5858 9.88558 20.3077 12.2117 20.3077 15.1582V17.1779H25.8462V15.1582C25.8462 11.296 24.8732 7.69235 22.6726 4.94712C20.4738 2.20188 16.9957 0.5625 12.9231 0.5625ZM16.6154 19.024C13.5582 19.024 11.0769 21.5053 11.0769 24.5625V43.024C11.0769 46.0813 13.5582 48.5625 16.6154 48.5625H42.4615C45.5188 48.5625 48 46.0813 48 43.024V24.5625C48 21.5053 45.5188 19.024 42.4615 19.024H16.6154ZM29.5385 28.2548C30.5177 28.2548 31.4569 28.6438 32.1493 29.3363C32.8418 30.0287 33.2308 30.9679 33.2308 31.9471C33.2308 33.3096 32.4849 34.48 31.3846 35.1207V39.3317C31.3846 40.349 30.5557 41.1779 29.5385 41.1779C28.5212 41.1779 27.6923 40.349 27.6923 39.3317V35.1207C26.592 34.48 25.8462 33.3114 25.8462 31.9471C25.8462 30.9679 26.2352 30.0287 26.9276 29.3363C27.62 28.6438 28.5592 28.2548 29.5385 28.2548Z",
    fill: "#ABE138"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19365_371271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockPadlock);
export default __webpack_public_path__ + "static/media/unlock-padlock.cc9fc591bde0377812f73e2dc449b71b.svg";
export { ForwardRef as ReactComponent };